import { Pipe, PipeTransform } from '@angular/core';
import {
    INTEGRATION_TASKS_EDUTONE_TITLE_MAP,
    INTEGRATION_TASKS_EDUTONE_TITLE_PLURAL_MAP
} from '@app/views/admin/application-settings/models/integration.model';

@Pipe({
    name: 'ngcEduToneEntityTitle'
})
export class EduToneEntityTitlePipe implements PipeTransform {

    transform(entity: string, plural: boolean = false): string {
        const TITLE_MAP = plural ? INTEGRATION_TASKS_EDUTONE_TITLE_PLURAL_MAP : INTEGRATION_TASKS_EDUTONE_TITLE_MAP;
        return (TITLE_MAP[entity] ? TITLE_MAP[entity] : entity);
    }
}
